import { initSubscribeEmailForm } from "../common/subscribeEmailForm";

document.addEventListener('DOMContentLoaded', () => {   
    initSubscribeEmailForm();
});